const localStorageData = JSON.parse(localStorage.getItem("catalogView"));
const layoutFiled = document.querySelector(".js-layout-field");
const layoutTriggersContainer = document.querySelector(".js-change-layout");

if (layoutFiled && localStorageData && layoutTriggersContainer) {
    if (localStorageData === "horizontal") {
        layoutFiled.classList.add("horizontal");
    } else if (localStorageData === "grid") {
        layoutFiled.classList.remove("horizontal");
    }
}

window.addEventListener("load", () => initChangeLayout(layoutTriggersContainer));

function initChangeLayout(triggerContainer) {
    if (triggerContainer && layoutFiled) {
        const triggerRow = triggerContainer.querySelector("[data-layout-trigger = row]");
        const triggerGrid = triggerContainer.querySelector("[data-layout-trigger = grid]");

        if (triggerRow && triggerGrid) {
            if (layoutFiled.classList.contains("horizontal")) {
                triggerRow.classList.add("active");
            } else {
                triggerGrid.classList.add("active");
            }
        }

        triggerContainer.addEventListener("click", (e) => {
            e.preventDefault();
            const trigger = e.target.closest("[data-layout-trigger]");

            if (trigger) {
                toggleLayout(trigger);
                toggleClasesOfAllTriggers();
            }
        });
    }
}

function toggleLayout(trigger) {
    const layout = trigger.dataset.layoutTrigger;

    if (layout === "row") {
        layoutFiled.classList.add("horizontal");
        localStorage.setItem("catalogView", JSON.stringify("horizontal"));
    }

    if (layout === "grid") {
        layoutFiled.classList.remove("horizontal");
        localStorage.setItem("catalogView", JSON.stringify("grid"));
    }
}

function toggleClasesOfAllTriggers() {
    const triggers = document.querySelectorAll("[data-layout-trigger]");

    for (const trigger of triggers) {
        trigger.classList.toggle("active");
    }
}
